import ContentLoader, { IContentLoaderProps } from 'react-content-loader';
const SummarySkeleton = (props: IContentLoaderProps) => {
  const { className = '', ...restProps } = props;
  return (
    <ContentLoader
      speed={2}
      // width={424}
      // height={70}
      viewBox="0 0 424 70"
      backgroundColor="#ECEEF3"
      foregroundColor="#DBDDE2"
      className={`bg-#F4F6F9CC rounded-4 ${className}`}
      {...restProps}
    >
      {/* <rect x="0" y="0" rx="16" ry="16" width="424" height="70" /> */}
      <rect x="16" y="16" rx="3" ry="3" width="392" height="6" />
      <rect x="16" y="32" rx="3" ry="3" width="392" height="6" />
      <rect x="16" y="48" rx="3" ry="3" width="200" height="6" />
    </ContentLoader>
  );
};

export default SummarySkeleton;
